// @flow

import * as React from 'react';

import { useDispatch } from 'react-redux';

import { removeDiscount, selectCartCurrency, getCart } from '@gandi/cart';

import { useTranslator } from '@gandi/translate';
import { Base, Svg } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { RemoveButton } from './RemoveButton';

import styles from './DiscountRow.scss';

type Props = {
  discount:
    | {
        code?: string,
        amount: number,
        label: string,
      }
    // Add type UnusedDiscount export in @gandi/cart UnusedDiscount,
    | {
        id: number,
        label: string,
      },
  setSuccess: React.ReactSetStateFunction<?string>,
};

function DiscountRow({
  discount,
  setSuccess,
}: Props): React.MixedElement | null {
  const dispatch = useDispatch();
  const { __, formatPrice } = useTranslator();
  const [loading, setLoading] = React.useState(false);

  const currency = useAppSelector(selectCartCurrency);

  const handleRemoveClick = async (evt: SyntheticEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    setLoading(true);
    try {
      const { code, id } = discount;
      // $FlowFixMe refine here
      await dispatch(removeDiscount(code ? { code } : { id }));
      await dispatch(getCart());
      setSuccess();
    } catch (err) {
      setLoading(false);
    }
  };

  if (!discount.amount) {
    return (
      <Base backgroundColor="surface" className={styles.container}>
        <div className={styles.unusedDiscount}>
          <Svg size="4x" name="warningWire" className={styles.warningIcon} />
          <p className={styles.discount}>{discount.label}</p>

          <p className={styles.info}>
            {__('This offer cannot be applied to your shopping cart')}
          </p>
        </div>
        <RemoveButton
          discount={discount}
          handleRemoveAction={handleRemoveClick}
          loading={loading}
        />
      </Base>
    );
  }

  const code = discount.code;
  if (!code) return null;

  const price = formatPrice(Math.abs(discount.amount), currency);
  return (
    <Base backgroundColor="surface" className={styles.container}>
      <div className={styles.info}>
        <Svg size="4x" name="miniCheckmark" className={styles.successIcon} />
        <Base
          tagName="p"
          dangerouslySetInnerHTML={__('%(code)s **%(price)s discount**', {
            code,
            price,
            withMarkdown: true,
          })}
        />
      </div>
      <RemoveButton
        discount={discount}
        handleRemoveAction={handleRemoveClick}
        loading={loading}
      />
    </Base>
  );
}

export default DiscountRow;
